import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/mosque/forgot-password', { email });
      setSent(true);
    } catch {
      setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      padding: 24,
    }}>
      <div style={{
        width: '100%',
        maxWidth: 420,
        background: 'var(--card)',
        borderRadius: 16,
        padding: '40px 36px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontFamily: 'Playfair Display', fontSize: 32, color: 'var(--primary-dk)', letterSpacing: -1, margin: '0 0 4px' }}>
            Ilmi<span style={{ color: 'var(--accent)' }}>fy</span>
          </h1>
          <p style={{ color: 'var(--text2)', fontSize: 14, margin: 0 }}>Passwort zurücksetzen</p>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: 56, height: 56, borderRadius: '50%',
              background: 'var(--primary-lt)', color: 'var(--primary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px', fontSize: 24,
            }}>
              ✓
            </div>
            <h3 style={{ margin: '0 0 10px', color: 'var(--text)' }}>E-Mail wurde gesendet</h3>
            <p style={{ color: 'var(--text2)', fontSize: 14, lineHeight: 1.6 }}>
              Falls ein Konto mit dieser E-Mail-Adresse existiert, erhalten Sie in Kürze einen Link zum Zurücksetzen des Passworts. Bitte prüfen Sie auch Ihren Spam-Ordner.
            </p>
            <Link to="/login" className="btn btn-primary w-full" style={{ marginTop: 24, display: 'block', textAlign: 'center' }}>
              Zurück zum Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ color: 'var(--text2)', fontSize: 14, marginBottom: 24, lineHeight: 1.6 }}>
              Geben Sie die E-Mail-Adresse Ihres Kontos ein. Wir senden Ihnen einen Link zum Zurücksetzen des Passworts.
            </p>

            {error && (
              <div style={{
                background: 'var(--error-lt)', color: 'var(--error)',
                border: '1px solid var(--error)', borderRadius: 8,
                padding: '10px 14px', marginBottom: 16, fontSize: 14,
              }}>
                {error}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">E-Mail-Adresse</label>
              <input
                type="email"
                className="form-input"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="login@moschee.de"
                required
                autoFocus
              />
            </div>

            <button type="submit" className="btn btn-primary w-full" disabled={loading} style={{ marginTop: 8 }}>
              {loading ? 'Wird gesendet…' : 'Link anfordern'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link to="/login" style={{ color: 'var(--text3)', fontSize: 14, textDecoration: 'none' }}>
                ← Zurück zum Login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
